import { onError } from '@apollo/client/link/error'
import { emitUnauthorizedRequest } from './utils/unauthorizedRequest.utils'
import { errorCodes } from '../../api/utils/apollo/errors/errorCodes'
import { type GraphQLFormattedError } from 'graphql'
import { camelCase } from 'change-case'

const SUPPORTED_REJECT_DETAIL_KEYS = ['noPartnerWriteAccess']

/**
 * Check if theres an error which contains a supported rejectDetails key:
 * {
 *   rejectDetails: {
 *     noPartnerWriteAccess: {
 *       partnerDetails: [{ name: 'partner1', id: 1 }, { name: 'partner2', id: 2 }]
 *     },
 *   }
 * }
 */
const getGraphQLErrorRejectDetails = (graphQLErrors: ReadonlyArray<GraphQLFormattedError>) => {
  const unauthorizedGraphQLError = graphQLErrors?.find(error => {
    if (error.extensions?.code !== errorCodes.NOT_AUTHORIZED) {
      return false
    }

    const rejectDetailsObject = error.extensions?.reject_details || error.extensions?.rejectDetails

    if (!rejectDetailsObject || typeof rejectDetailsObject !== 'object') {
      return false
    }

    return Object.keys(rejectDetailsObject).some(
      key => key && SUPPORTED_REJECT_DETAIL_KEYS.includes(camelCase(key))
    )
  })

  if (!unauthorizedGraphQLError) {
    return null
  }

  return (
    unauthorizedGraphQLError.extensions?.rejectDetails ||
    unauthorizedGraphQLError.extensions.reject_details
  )
}

export const unauthorizedRequestLink = onError(({ graphQLErrors }) => {
  const rejectDetails = getGraphQLErrorRejectDetails(graphQLErrors)

  if (rejectDetails) {
    Object.keys(rejectDetails).forEach(key => {
      if (camelCase(key) === 'noPartnerWriteAccess') {
        const partnerNames = rejectDetails[key]?.partnerDetails?.map(p => p.name) || []
        const partnerIds = rejectDetails[key]?.partnerDetails?.map(p => p.id) || []

        emitUnauthorizedRequest('partnerWriteAccessError', {
          partnerNames,
          partnerIds,
        })
      }
    })
  }
})
